import * as faker from 'faker';

import { titleCase } from '@library/common/functions';

import { ShipmentSnapshot } from './shipment-snapshot';

import { Milestones } from '@library/common/models';
import {
   ShipmentTypes, ShipmentModes,
   MockHawb,
   MockBillingParty,
   MockStatus,
   MockReference,
} from '@library/common/models/mock';

export class MockShipmentSnapshot extends ShipmentSnapshot {
   constructor() {
      super();

      this.shipType = faker.random.arrayElement( ShipmentTypes );
      this.mode = this.shipType === 'domestic' ? 'road' : faker.random.arrayElement( ShipmentModes );
      this.hawb = MockHawb();
      this.references = Array.from({ length: faker.datatype.number( 20 ) }, _ => new MockReference() );
      this.servicelevel = titleCase( faker.lorem.words(2) ) as string;
      this.statuses = Array.from({ length: faker.datatype.number( 5 ) }, _ => new MockStatus() );

      this.milestones = Milestones( this.mode );
      Object.keys( this.milestones ).slice( 0, faker.datatype.number({
         min: 1,
         max: Object.keys( this.milestones ).length,
      })).map( key => this.milestones[key] = faker.date.past() );

      this.shipper = new MockBillingParty();
      this.consignee = new MockBillingParty();
      this.bill_to = new MockBillingParty();
   }
}
